var mapStyle = [

        {
          "featureType": "landscape",
          "stylers": [
            {
              "color": "#5ab1e5"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#5ab1e5"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.icon",
          "stylers": [
            {
              "color": "#283641"
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "stylers": [
            {
              "color": "#467491"
            }
          ]
        }
      
]
// var mapStyle = [
//     {
//         "featureType": "landscape",
//         "elementType": "geometry",
//         "stylers": [{
//             "color": "#F8F8F8"
//         }]
//     }, {
//         "featureType": "water",
//         "stylers": [{
//             "color": "#D7D7D7"
//         }]
//     }, {
//         "featureType": "poi",
//         "stylers": [{
//             "color": "#D7D7D7"
//         }]
//     }, {
//         "featureType": "administrative.locality",
//         "stylers": [ { 
//             "visibility": "on" 
//         }]
//     }, {
//         "featureType": "road.highway",
//         "stylers": [{
//             "color": "#d98080"
//         }, {
//             "hue": "#eeff00"
//         }, {
//             "lightness": 100
//         }, {
//             "weight": 1.5
//         }]
//     }, {
//         "featureType": "transit",
//         "elementType": "labels",
//         "stylers": [{
//             "visibility": "off"
//         }]
//     }, {
//         "elementType": "labels.text.stroke",
//         "stylers": [{
//             "visibility": "on"
//         }, {
//             "color": "#ffffff"
//         }, {
//             "lightness": 16
//         }]
//     }, {
//         "elementType": "labels.text.fill",
//         "stylers": [{
//             "saturation": 36
//         }, {
//             "color": "#333333"
//         }, {
//             "lightness": 0
//         }]
//     }
// ];

exports.mapStyle = mapStyle;